import { ObjectFileTypeEnum } from "@aichat/types/index";
import { axiosInstance } from "../lib/axios";

export const uploadFileWithPresignedUrl = async ({
  preSignedUrl,
  file,
  fileType,
}: {
  preSignedUrl: string;
  file: File;
  fileType: string;
}) => {
  const response = await axiosInstance.put(preSignedUrl, file, {
    headers: {
      "Content-Type": fileType,
    },
  });
  if (response.status === 200) {
    return "ok";
  } else {
    throw new Error("Something went wrong");
  }
};

export const generatePresignedUrl = async ({
  projectId,
  fileName,
  type,
  contentType,
  organizationId,
}: {
  projectId: string;
  fileName: string;
  type: ObjectFileTypeEnum;
  contentType: string;
  organizationId: string;
}): Promise<{ url: string; objectKey: string; globalUrl: string }> => {
  const payload = {
    fileName,
    type,
    contentType,
  };

  const response = await axiosInstance.post<{
    url: string;
    objectKey: string;
    globalUrl: string;
  }>(`/storage/${projectId}/generate-presigned-url/public`, payload, {
    params: {
      organizationId,
    },
  });

  return response.data;
};
